import React, { useState, useEffect } from 'react';
import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CheckIcon from '@mui/icons-material/Check';
import Info from '@mui/icons-material/Info';
import IconButton from '@mui/material/IconButton';

const SnackbarConsent = () => {
  const [showSnackbar, setShowSnackbar] = useState(false);

  useEffect(() => {
    // Check if the consent cookie exists and its value
    const consentCookie = document.cookie.split(';').find((item) => item.trim().startsWith('consent_given='));
    const consentGiven = consentCookie && consentCookie.split('=')[1];

    if (consentGiven === 'true') {
      // If consent is given, update Google Consent Mode
      if (window.gtag) {
        window.gtag('consent', 'update', {
          'ad_storage': 'granted',
          'analytics_storage': 'granted',
          'ad_personalization': 'granted',
          'ad_user_data': 'granted'
        });
        console.log("Consent: Granted.")
      }
    } else if (consentGiven === 'false') {
      // If consent is denied, update Google Consent Mode
      if (window.gtag) {
        window.gtag('consent', 'update', {
          'ad_storage': 'denied',
          'analytics_storage': 'denied',
          'ad_personalization': 'denied',
          'ad_user_data': 'denied'
        });
        console.log("Consent: Denied.")
      }
    } else {
      // If consent hasn't been given, show the Snackbar
      setShowSnackbar(true);
    }
  }, []);

  const handleConsent = (consent) => {
    // Set the consent cookie and update Google Consent Mode
    const date = new Date();
    date.setTime(date.getTime() + (365 * 24 * 60 * 60 * 1000));
    const expires = "; expires=" + date.toUTCString();
    
    if (consent) {
      document.cookie = "consent_given=true" + expires + "; path=/";
      if (window.gtag) {
        window.gtag('consent', 'update', {
          'ad_storage': 'granted',
          'analytics_storage': 'granted',
          'ad_personalization': 'granted',
          'ad_user_data': 'granted'
        });
      }
    } else {
      document.cookie = "consent_given=false" + expires + "; path=/";
      if (window.gtag) {
        window.gtag('consent', 'update', {
          'ad_storage': 'denied',
          'analytics_storage': 'denied',
          'ad_personalization': 'denied',
          'ad_user_data': 'denied'
        });
      }
    }

    setShowSnackbar(false);
  };

  const acceptCookies = () => {
    handleConsent(true);
  };

  const declineCookies = () => {
    handleConsent(false);
  };

  return (
    <Snackbar 
      open={showSnackbar} 
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{
        width: '100%',
        left: 0,
        right: 0,
      }}
    >
      <Alert
        severity="info"
        sx={{
          backgroundColor: 'background.default',
          boxShadow: 3,
          display: "flex",
          alignItems: "flex-start",
          p: 2,
          borderRadius: 1,
        }}
        icon={
          <IconButton aria-label='Info' disabled>
            <Info />
          </IconButton>
        }
        action={
          <IconButton aria-label='Check' onClick={() => setShowSnackbar(false)} sx={{ display: "flex" }}>
            <CheckIcon />
          </IconButton>
        }
      >
        <Box display="flex" flexDirection="column" alignItems="center" textAlign="center">
          <Typography variant="h6" component="div" gutterBottom>
            We use cookies
          </Typography>
          <Typography variant="body2" color="textSecondary" component="p" gutterBottom>
            This website uses cookies to improve user experience. By continuing to use this site, you accept our use of cookies.
          </Typography>
          <Box mt={2} display="flex" justifyContent="space-around" width="100%">
            <Button aria-label="Decline Terms" fullWidth variant="outlined" onClick={declineCookies} sx={{ mx: 0.5 }}>
              Decline
            </Button>
            <Button aria-label="Accept Terms" fullWidth variant="contained" color="primary" onClick={acceptCookies} sx={{ mx: 0.5 }}>
              Accept
            </Button>
          </Box>
        </Box>
      </Alert>
    </Snackbar>
  );
};

export default SnackbarConsent;
